import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export function getUserNotifications(data) {
	const url = `${API_URL}/user/notifications`;
	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'GET',
		// "headers": {: {Pragma: 'no-cache'},
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings);
}

export function removeUserNotification(data) {
	const url = `${API_URL}/user/notification/${data.notification_id}`;

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'DELETE',
		// "headers": {: {},
		withCredentials: true,

	}

	return axios(settings);
}

export function viewedUserNotifications(data) {
	const url = `${API_URL}/user/notifications/markasviewed`;

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'POST',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		withCredentials: true,
	}

	return axios(settings);
}

export function getAssignedUsersOfCompany(data) {
	let url;
	switch (data.userRole) {
		case 'system_admin':
			url = `${API_URL}/system_admin/partner/${data.partnerName}/company/${data.companyName}/assignedusers`;
			break;
		case 'customer_service':
			url = `${API_URL}/customer_service/partner/${data.partnerName}/company/${data.companyName}/assignedusers`;
			break;
		default:
			break;
	}

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'GET',
		// "headers": {: {Pragma: 'no-cache'},
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings);
}

export function getUserInfo() {
	const url = `${API_URL}/users/me`;

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'GET',
		// headers: {Pragma: 'no-cache'},
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings);
}

export function createFleetUser(data) {
   	const url = `${API_URL}/users/${data.email}`;

   	const form = new FormData();
	form.append('last_name', data.last_name);
	form.append('first_name', data.first_name);
	form.append('roles', data.role);
	form.append('password', data.password);
	form.append('phone_number', '1234567890');
	data.company_name ? form.append('company_name', data.company_name) : '';
	data.partner_name ? form.append('partner_name', data.partner_name) : '';

   	const settings = {
       "async": true,
       "crossDomain": true,
       "url": url,
       "method": "PUT",
       // "headers": {: {},
       "processData": false,
       "contentType": false,
       "mimeType": "multipart/form-data",
       "data": form,
       "dataType": 'jsonp',
       "withCredentials": true
   }

   return axios(settings);
}

export function createFleetUserWithGroup (data, userRole, callback) {
	let url;
	switch (userRole) {
		case 'fleet_manager':
		case 'storage_manager':
			url = `${API_URL}/users/${data.email}`;
			break;
		case 'system_admin':
			url = `${API_URL}/system_admin/users/${data.email}`;
			break;
		case 'customer_service':
			url = `${API_URL}/customer_service/users/${data.email}`;
			break;
		case 'partner':
		case 'custom_partner':
			url = `${API_URL}/partners/users/${data.email}`;
			break;
	}

	const form = new FormData();
	form.append('last_name', data.last_name);
	form.append('first_name', data.first_name);
	form.append('roles', data.role);
	form.append('password', data.password);
	form.append('phone_number', '12345678');
	data.company_name ? form.append('company_name', data.company_name) : '';
	data.partner_name ? form.append('partner_name', data.partner_name) : '';

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'PUT',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		dataType: 'jsonp',
		withCredentials: true,
	}

	axios(settings)
		.then((resUser, err) => {
			if (data.group) {
				let groups = [];
				if (Array.isArray(data.group)) {
					data.group.forEach((item) => {
						groups.push(item.value);
					});
				}
				else {
					groups = data.group.split(',');
				}

				let i = 0;
				groups.forEach((item) => {
					let groupUrl;
					switch (userRole) {
						case 'fleet_manager':
						case 'storage_manager':
							groupUrl = `${API_URL}/groups/${item}/users/${data.email}`;
							break;
						case 'system_admin':
							// groupUrl = `${API_URL}/system_admin/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							groupUrl = `${API_URL}/system_admin/partner/${data.partner_name}/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							break;
						case 'customer_service':
							groupUrl = `${API_URL}/customer_service/partner/${data.partner_name}/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							break;
						case 'partner':
						case 'custom_partner':
							groupUrl = `${API_URL}/partners/companies/${data.company_name}/groups/${item}/users/${data.email}`;
							break;
						default:
							break;
					}

					let settings = {
						async: true,
						crossDomain: true,
						url: groupUrl,
						method: 'PUT',
						// "headers": {: {},
						dataType: 'jsonp',
						withCredentials: true,
					}

					axios(settings).then((res, err)=> {
						i++;
						if (i == data.group.length) {
							if (typeof callback === 'function') {
								return callback(null, {result:'ok', user_id: resUser.data.response.user.id})
							}
						}
					})
					.catch((error) => {
						if (typeof callback === 'function') {
							return callback(error, null)
						}
					});
				});
			} else {
				if (typeof callback === 'function') {
					return callback(null, {result:'ok', user_id: resUser.data.response.user.id});
				}
			}
		})
		.catch((error)=>{
			if (typeof callback === 'function') {
				return callback(error, null);
			}
		});
}

export function updateFleetUser(data) {
	let url
	switch (data.user_role) {
	case 'fleet_manager':
	case 'fleet_maintainer':
	case 'storage_manager':
	case 'group_manager':
	case 'user':
		url = `${API_URL}/users/${data.user_email}`
		break;
	case 'system_admin':
		url = `${API_URL}/system_admin/users/${data.user_email}`
		break;
	case 'customer_service':
		url = `${API_URL}/customer_service/users/${data.user_email}`
		break;
	case 'partner':
	case 'custom_partner':
		url = `${API_URL}/partners/users/${data.user_email}`
		break;
	default:
		break;
	}

	const form = new FormData();
	const user = data.data
	Object.keys(user).forEach((key) => {
		form.append(key, user[key])
	})

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'POST',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings)
}

export function updateFleetUserSettings (data) {
	let url
	switch (data.user_role) {
		case 'fleet_manager':
		case 'storage_manager':
			url = `${API_URL}/users/${data.user_email}/settings`
			break;
		case 'system_admin':
			url = `${API_URL}/system_admin/users/${data.user_email}/settings`
			break;
		case 'customer_service':
			url = `${API_URL}/customer_service/users/${data.user_email}/settings`
			break;
		case 'partner':
		case 'custom_partner':
			url = `${API_URL}/partners/users/${data.user_email}/settings`
			break;
	}

	const form = new FormData(),
	user = data.data
	for (const key in user){
		form.append(key, user[key])
	}

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'PUT',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		dataType: 'jsonp',
		withCredentials: true,
	}

	axios(settings)
}

export function deleteFleetUser(email) {
	const url = `${API_URL}/users/${email}`
	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'DELETE',
		// "headers": {: {},
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings);
}

export function getUsers(userRole, company) {
	let url;
	switch (userRole) {
	case 'system_admin':
		url = `${API_URL}/system_admin/partner/${company.partner}/companies/${company.name}/users`;
		break;
	case 'customer_service':
		url = `${API_URL}/customer_service/partner/${company.partner}/companies/${company.name}/users`;
		break;
	case 'partner':
	case 'custom_partner':
		url = `${API_URL}/partners/companies/${company.name}/users`;
		break;
	case 'fleet_maintainer':
	case 'fleet_manager':
	case 'group_manager':
	case 'storage_manager':
	case 'custom_user':
		url = `${API_URL}/users`;
		break;
	case 'sales_demo':
		url = `${API_URL}/sales_demo/partner/${company.partner}/companies/${company.name}/users`;
		break;
	default:
		break;
	}

	if (company.roles) {
		url += `?roles=${company.roles}`
	}

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'GET',
		// "headers": {: {Pragma: 'no-cache'},
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings);
}

export function getAllUsers(){
    const url = `${API_URL}/users/list`;

    const settings = {
        "async": true,
        "crossDomain": true,
        "url": url,
        "method": "GET",
        "dataType": 'jsonp',
        "withCredentials": true
    }

    return axios(settings);
}

export function changeUserPassword (data) {
	const url = `${API_URL}/users/${data.user_email}/change`;
	const form = new FormData();
	form.append('new_password', data.new_password);
	form.append('new_password_confirm', data.new_password_confirm);

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'POST',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		// "dataType": 'jsonp',
		withCredentials: true,
	}

	return axios(settings);
}

export function activateUserAccount (email) {
	const url = `${API_URL}/customer_service/users/confirm`;
	const form = new FormData();
	form.append('emails', email);

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'POST',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		withCredentials: true,
	}

	return axios(settings);
}

export function getDokuWikiEULA(env) {
	let url;

	switch (env) {
		case 'localhost':
			// // url = `http://localhost/dokuwiki/_export/html/user:product:roscolive:roscolive2.0:eula`;
			// url = 'http://localhost/dokuwiki/_export/html/user:product:roscolive2.0:eula';
			// break;
		case 'test.roscolive.com':
		case 'dev.roscolive.com':
		case 'staging.roscolive.com':
			// url = `https://devwiki.roscocloud.com/_export/html/user:product:roscolive:roscolive2.0:eula`;
			// url = 'https://devwiki.roscocloud.com/_export/html/user:product:roscolive2.0:eula';
			// break;
		case 'canada.roscolive.com':
		case 'roscocloud.com':
		case 'www.roscocloud.com':
		case 'fleet.roscolive.com':
			// url = `https://wiki.roscocloud.com/_export/html/user:product:roscolive:roscolive2.0:eula`;
			url = 'https://support.roscovision.com/roscolive-eula';
			break;
	}

	const settings = {
		url,
		method: 'GET',
		dataType: 'text/html',
	};

	return axios(settings);
}

export function agreeDokuWikiEULA() {
	const url = `${API_URL}/user/eula/view`;

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'POST',
		// "headers": {: {},
		processData: false,
		contentType: false,
		// "mimeType": "multipart/form-data",
		// "data": form,
		withCredentials: true,
	};

	return axios(settings);
}

export function viewedLastReleaseDescription(timeReviewed) {
	const url = `${API_URL}/user/release/view`;

	const form = new FormData()
	form.append('time_reviewed', timeReviewed)

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'POST',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		withCredentials: true,
	};

	return axios(settings);
}

export function addAuditLog(data) {
	const url = `${API_URL}/users/auditlogs`
	const form = new FormData()
	form.append('action', data.action)
	form.append('action_data', JSON.stringify(data.action_data))

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'PUT',
		// "headers": {: {},
		processData: false,
		contentType: false,
		mimeType: 'multipart/form-data',
		data: form,
		dataType: 'jsonp',
		withCredentials: true,
	}

	return axios(settings)
}

export function getUserLogs(data) {
	let url = `${API_URL}/users/${data.user_id}/auditlog?start_date=${data.start_date}&end_date=${data.end_date}`
	if (data.filter_type) {
		url =  url + `&filter_type=${data.filter_type}`
	}

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'GET',
		// "headers": {Pragma: 'no-cache'},
		withCredentials: true,
	}

	return axios(settings)
}

export function getCompanyLogs(data) {
	let url
	switch (data.user_role) {
		case 'system_admin':
		case 'customer_service':
		case 'sales_demo':
			url = `${API_URL}/companies/${data.company_id}/auditlog?start_date=${data.start_date}&end_date=${data.end_date}`
			break
		default:
			break;
	}
	if (data.filter_type) {
		url =  url + `&filter_type=${data.filter_type}`
	}

	const settings = {
		async: true,
		crossDomain: true,
		url,
		method: 'GET',
		// "headers": {Pragma: 'no-cache'},
		withCredentials: true,
	}

	return axios(settings)
}
